// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CareersCard_wrapper__qu4DQ","imageWrapper":"CareersCard_imageWrapper__xlSRT","image":"CareersCard_image__MNsNm","detailsWrapper":"CareersCard_detailsWrapper__NeCH_"};